import { createContext, useContext, useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(undefined); // undefined = carregando
  const [userType, setUserTypeState] = useState(() => localStorage.getItem("user_type"));

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session ?? null);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      setSession(session ?? null);
      if (event === "SIGNED_OUT") {
        setUserTypeState(null);
        localStorage.removeItem("user_type");
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  const setUserType = (type) => {
    setUserTypeState(type);
    if (type) localStorage.setItem("user_type", type);
    else localStorage.removeItem("user_type");
  };

  return (
    <AuthContext.Provider value={{ session, userType, setUserType }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
